import { render, staticRenderFns } from "./TheIcon.vue?vue&type=template&id=6e455a2c&scoped=true"
import script from "./TheIcon.vue?vue&type=script&lang=js"
export * from "./TheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e455a2c",
  null
  
)

export default component.exports